import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Typography } from '@mui/material';

const styles = {
  container: {
    padding: 10,
  },
};

export default function Appendices(props) {
  const { year, month } = props;

  return (
    <Container sx={styles.container}>
      <Typography variant='h4'>Appendices</Typography>
      <Typography variant='subtitle1'>
        <Link to='/appendix/a' target='_blank'>
          Appendix A - Abbreviations / Acronyms
        </Link>
      </Typography>
      <Typography variant='subtitle1'>
        <Link to='/appendix/b' target='_blank'>
          Appendix B - Special Provision Description
        </Link>
      </Typography>
      <Typography variant='subtitle1'>
        <Link to={`/appendix/c/${year}-${month}`} target='_blank'>
          Appendix C - Summary
        </Link>
      </Typography>
      <Typography variant='subtitle1'>
        <Link to={`/appendix/d/${year}-${month}`} target='_blank'>
          Appendix D - Continued Applicants
        </Link>
      </Typography>
      <Typography variant='subtitle1'>
        <Link to={`/appendix/e/${year}-${month}`} target='_blank'>
          Appendix E - Administrative Modifications
        </Link>
      </Typography>
      <Typography variant='subtitle1'>
        <Link to={`/appendix/f/${year}-${month}`} target='_blank'>
          Appendix F - Advertised in Error
        </Link>
      </Typography>
      <Typography variant='subtitle1'>
        <Link to={`/appendix/g/${year}-${month}`} target='_blank'>
          Appendix G - Outcome of Permits Advertised for Cancellation
        </Link>
      </Typography>
      <Typography variant='subtitle1'>
        <Link to={`/appendix/h/${year}-${month}`} target='_blank'>
          Appendix H - Lake Makeup Report
        </Link>
      </Typography>
      <Typography variant='subtitle1'>
        <Link to={`/appendix/i/${year}-${month}`} target='_blank'>
          Appendix I - New Wells Report
        </Link>
      </Typography>
      <Typography variant='subtitle1'>
        <Link to={`/appendix/j/${year}-${month}`} target='_blank'>
          Appendix J - Take No Action Applications
        </Link>
      </Typography>
    </Container>
  );
}
